var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "row mb-prj align-items-center bg-shade-light small-collapse",
      attrs: { id: _vm.fileid },
    },
    [
      !_vm.compact
        ? _c("div", { staticClass: "column large-1 flex-child-fix" }, [
            _c(
              "figure",
              {
                staticClass:
                  "content-list__figure bg-shade embed-responsive embed-responsive-1/1 position-relative flex-child-fix",
              },
              [
                !_vm.isPDF
                  ? _c("img", {
                      staticClass: "object-fit-contain",
                      attrs: { src: _vm.iconURL, alt: "no image available" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isPDF
                  ? _c("PdfPreview", { attrs: { file: _vm.internalFile } })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "column small-5 medium-7" }, [
        _c(
          "div",
          {
            staticClass:
              "content-list__desc d-block mx-prj2 line-height-12 text-xsmall text-small@medium text-left",
          },
          [
            _c("span", { staticClass: "font-weight-bold text-break" }, [
              _vm._v(_vm._s(_vm.filename)),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column small-3 d-flex align-content-center" }, [
        _c("div", { staticClass: "status" }, [
          _vm.filestatus === _vm.FILESTATUS.OK
            ? _c(
                "div",
                {
                  staticClass:
                    "upload__success text-success d-flex align-items-center",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "svg-icon upload-icon svg-icon--large mr-2 show-for-medium",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        x: "0",
                        y: "0",
                        viewBox: "0 0 36 36",
                        "xml:space": "preserve",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01z",
                          fill: "#62b982",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "XMLID_1_",
                          d: "M14.93 26.67l-6.46-6.46a2.07 2.07 0 010-2.93 2.07 2.07 0 012.93 0l3.55 3.55 9.66-9.56c.81-.8 2.12-.8 2.93.02.8.81.8 2.12-.02 2.93L14.93 26.67z",
                          fill: "#fff",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.compact
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-xxsmall text-small@medium text-center",
                        },
                        [_vm._v(_vm._s(_vm._f("translate")("txtFileUploaded")))]
                      )
                    : _vm._e(),
                ]
              )
            : _vm.filestatus === _vm.FILESTATUS.ERROR_FILETYPE
            ? _c(
                "div",
                { staticClass: "upload__error d-flex align-items-center" },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "svg-icon upload-icon svg-icon--large mr-2 show-for-medium",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 36 36",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: { cx: "18", cy: "18", r: "18", fill: "#e94d47" },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                          fill: "#fff",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.compact
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-error text-xxsmall text-small@medium text-center",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("translate")("txtErrorFileUpload"))
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            : _vm.filestatus === _vm.FILESTATUS.ERROR_FILESIZE
            ? _c(
                "div",
                { staticClass: "upload__error d-flex align-items-center" },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "svg-icon upload-icon svg-icon--large mr-2 show-for-medium",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 36 36",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: { cx: "18", cy: "18", r: "18", fill: "#e94d47" },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                          fill: "#fff",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.compact
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-error text-xxsmall text-small@medium text-center",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("translate")("txtErrorFileTooBig"))
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            : _c("div", { staticClass: "upload__uploading" }, [
                _c(
                  "svg",
                  {
                    staticClass:
                      "svg-icon upload-icon m-auto svg-icon--large position-relative t-2px",
                    attrs: {
                      "xmlns:svg": "http://www.w3.org/2000/svg",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      version: "1.0",
                      width: "64px",
                      height: "64px",
                      viewBox: "0 0 128 128",
                      "xml:space": "preserve",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        x: "0",
                        y: "0",
                        width: "100%",
                        height: "100%",
                        fill: "#E1E6EE",
                      },
                    }),
                    _c(
                      "g",
                      [
                        _c("path", {
                          attrs: {
                            fill: "#0096d1",
                            "fill-opacity": "1",
                            d: "M109.25 55.5h-36l12-12a29.54 29.54 0 0 0-49.53 12H18.75A46.04 46.04 0 0 1 96.9 31.84l12.35-12.34v36zm-90.5 17h36l-12 12a29.54 29.54 0 0 0 49.53-12h16.97A46.04 46.04 0 0 1 31.1 96.16L18.74 108.5v-36z",
                          },
                        }),
                        _c("animateTransform", {
                          attrs: {
                            attributeName: "transform",
                            type: "rotate",
                            from: "0 64 64",
                            to: "360 64 64",
                            dur: "1120ms",
                            repeatCount: "indefinite",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.filestatus !== _vm.FILESTATUS.LOADING
        ? _c(
            "div",
            { staticClass: "column large-1 d-flex align-content-center" },
            [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn--link m-auto w-auto p-0 border-0 position-relative tn-1px",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("delete-file")
                    },
                  },
                },
                [_c("div", { staticClass: "icon-up-delete" })]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }